// GENERATED by :cmp-navigation:generateFeatureKoinBindings — do not edit.
package cmp.navigation.registry

import org.koin.core.module.Module
import org.koin.dsl.module
import kpt.feature.addtowatchlist.di.AddToWatchlistModule
import kpt.feature.alerts.di.AlertsModule
import kpt.feature.amortization.di.AmortizationModule
import kpt.feature.bills.di.BillsModule
import kpt.feature.calculators.di.CalculatorsModule
import kpt.feature.cloudtodo.di.CloudTodoModule
import kpt.feature.crypto.di.CryptoFeatureModule
import kpt.feature.currencyrates.di.CurrencyRatesModule
import kpt.feature.emicalculator.di.EmiCalculatorModule
import kpt.feature.home.di.HomeModule
import kpt.feature.loans.di.LoansModule
import kpt.feature.macro.di.MacroModule
import kpt.feature.profile.di.ProfileModule
import kpt.feature.rates.di.RatesModule
import kpt.feature.settings.di.SettingsModule
import kpt.feature.watchlist.di.WatchlistModule

/** Every feature module's Koin module, derived from source. */
public val GeneratedFeatureKoinBindings: Module = module {
    includes(AddToWatchlistModule)
    includes(AlertsModule)
    includes(AmortizationModule)
    includes(BillsModule)
    includes(CalculatorsModule)
    includes(CloudTodoModule)
    includes(CryptoFeatureModule)
    includes(CurrencyRatesModule)
    includes(EmiCalculatorModule)
    includes(HomeModule)
    includes(LoansModule)
    includes(MacroModule)
    includes(ProfileModule)
    includes(RatesModule)
    includes(SettingsModule)
    includes(WatchlistModule)
}
